/* Only gets fired on the client */
import { replace } from 'react-router-redux';
import Promise from 'bluebird';
import { AppEnvs, Device, Flags } from 'enums';
import { replaceHero } from 'page/actions';
import { contentIdInPlayerUrl } from 'selectors/appSelector';
import pageSelector from 'selectors/pageSelector';
import { getContentPlaylistFromBuckets } from 'player/util';
import queryString from 'lib/format/queryString';
import { xDeviceMap } from '../../constants';
import { appEnv } from './../../../config';
import fallbackConfigQa from './../../../config/watchespn-web-1.0.config.qa.json';
import fallbackConfig from './../../../config/watchespn-web-1.0.config.json';

export const ANALYTICS_READY = 'ANALYTICS_READY';
export const CLOSE_MODAL_MESSAGE = 'CLOSE_MODAL_MESSAGE';
export const CONTENT_SELECT = 'CONTENT_SELECT';
export const CONTENT_UNSELECT = 'CONTENT_UNSELECT';
export const DISPLAY_MODAL_MESSAGE = 'DISPLAY_MODAL_MESSAGE';
export const MEDIA_QUERY = 'MEDIA_QUERY';
export const INIT_APP_DATA = 'INIT_APP_DATA';
export const FETCH_EXTERNAL_CONFIG = 'FETCH_EXTERNAL_CONFIG';
export const FETCH_EMBEDDED_OPTIONS = 'FETCH_EMBEDDED_OPTIONS';

export function displayModalMessage(messageType, messageData) {
    return {
        type: DISPLAY_MODAL_MESSAGE,
        messageType,
        messageData
    };
}

export function closeModalMessage() {
    return {
        type: CLOSE_MODAL_MESSAGE
    };
}

function updatePlayerRoute({ id, bucketId }) {
    return (dispatch) => {
        const qs = queryString({ id, bucketId });
        dispatch(replace(`/player${qs}`));
    };
}

export function contentSelect(content) {
    return (dispatch, getState) => {
        const state = getState();
        const playerUrlId = contentIdInPlayerUrl(state);
        if (playerUrlId && playerUrlId !== content.id) {
            dispatch(replaceHero(content));
            dispatch(updatePlayerRoute(content));
        }
        const buckets = pageSelector(state).buckets || [];
        const { app: { isMobile = false } = {} } = getState();
        if (!isMobile) {
            content.playlist = getContentPlaylistFromBuckets(content, buckets);
        }

        dispatch({
            type: CONTENT_SELECT,
            content,
            clickedTime: Date.now()
        });
    };
}

export function contentUnSelect(content) {
    return {
        type: CONTENT_UNSELECT,
        content,
        clickedTime: Date.now()
    };
}

export function analyticsReady(initData = {}) {
    return {
        type: ANALYTICS_READY,
        initData,
        completeTime: Date.now()
    };
}

export function fetchExternalConfig() {
    return (dispatch) => {
        let config = fallbackConfigQa;
        if (appEnv === AppEnvs.prod) {
            config = fallbackConfig;
        }
        dispatch({
            type: FETCH_EXTERNAL_CONFIG,
            bootstrap: config
        });
    };
}

// embedded options are defined in enums.js -> Flags
// mobile apps will inject a global function that returns the options object.
// sample implementation:
// function getEmbeddedOptions() {
//     return {
//         playertech: "brightcove",
//         roadblock: false
//     };
// }
export function fetchEmbeddedOptions() {
    return (dispatch) => {
        const options = global.getEmbeddedOptions ? global.getEmbeddedOptions() : {};

        const flags = Object.keys(Flags).map((key) => Flags[key]);
        const whitelistedOptions = Object.keys(options)
            .filter((key) => flags.indexOf(key) !== -1)
            .reduce((map, key) => {
                map[key] = options[key];
                return map;
            }, {});

        dispatch({
            type: FETCH_EMBEDDED_OPTIONS,
            options: whitelistedOptions
        });

        return Promise.resolve(whitelistedOptions);
    };
}

export function initAppData({
    device: deviceArg = Device.DESKTOP,
    env,
    location,
    lang,
    country = 'us',
    locale,
    messages
}) {
    const device = xDeviceMap[deviceArg] || Device.DESKTOP;
    const isMobile = (device === Device.HANDSET || device === Device.TABLET);

    return {
        type: INIT_APP_DATA,
        device,
        env,
        isMobile,
        location,
        lang,
        country,
        locale,
        messages
    };
}

export function mediaQuery(mq) {
    return {
        type: MEDIA_QUERY,
        mq
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/appActions.js